
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            제품 관리 - 1단계 : 제품 타입 {{ $route.query.product_type_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.product_type_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_type_kor_name'>제품타입 한글명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_type_kor_name'
                maxLength="100"
                placeholder = "제품타입 한글명을 입력해 주세요."
                v-model="formData.productTypeKorName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productTypeKorNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_type_eng_name'>제품타입 영문명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_type_eng_name'
                maxLength="100"
                placeholder = "제품타입 영문명을 입력해 주세요."
                v-model="formData.productTypeEngName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productTypeEngNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_type_activate'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_type_activate"
                v-model="formData.productTypeActivate"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_product_type_one,
  insert_product_type,
  update_product_type
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminProductTypeManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        productTypeKorName: '',
        productTypeEngName: '',
        productTypeActivate: 1
      }),
      errorData: ref({
        productTypeKorNameError: '',
        productTypeEngNameError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_form: function () {
      let continue_add = true
      if (this.formData.productTypeKorName === '') {
        this.errorData.productTypeKorNameError = '제품타입 한글명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productTypeKorNameError = ''
      }
      if (this.formData.productTypeEngName === '') {
        this.errorData.productTypeEngNameError = '제품타입 영문명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productTypeEngNameError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.product_type_ID === undefined) {
          insert_product_type(
            this.formData.productTypeKorName,
            this.formData.productTypeEngName
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminProductTypeManagement'
          })
        } else {
          update_product_type(
            this.$route.query.product_type_ID,
            this.formData.productTypeKorName,
            this.formData.productTypeEngName,
            this.formData.productTypeActivate
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminProductTypeManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.product_type_ID !== undefined) {
      get_product_type_one(this.$route.query.product_type_ID).then((result) => {
        this.formData.productTypeKorName = result[0].product_type_kor_name
        this.formData.productTypeEngName = result[0].product_type_eng_name
        this.formData.productTypeActivate = result[0].product_type_activate
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ProductManagement/AdminProductTypeManagementAdd.vue